import { useEffect } from 'react';

import { POLICIES } from '@vlabs/api-bindings/src/luna-client/handlers/constants';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CallbackPolicyForm.module.sass';
import { defaultHttpValues, defaultTelegramValues } from './defaultValues';
import { HttpCallbackPolicyForm } from './HttpCallbackPolicyForm';
import { TelegramNotificationForm } from './TelegramNotificationForm';

interface TSelectOption {
  label: string; value: unknown;
}

interface CallbackPolicyFormProp {
  callbackTypeOptions?: TSelectOption[];
  fieldName?: string;
}

export function CallbackPolicyForm({
  callbackTypeOptions = undefined,
  fieldName = undefined,
}: CallbackPolicyFormProp): JSX.Element {
  const { t } = useTranslation();
  const prefix = fieldName ? `${fieldName}.` : '';
  const { control, unregister, setValue } = useFormContext();
  const callbackType = useWatch({ name: `${prefix}type` })?.value;

  useEffect(() => {
    unregister(`${prefix}authorization`);
    unregister(`${prefix}url`);
    unregister(`${prefix}params`);

    Object.entries(callbackType === 'http' ? defaultHttpValues : defaultTelegramValues).forEach(([key, value]) => {
      setValue(`${prefix}${key}`, value);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callbackType, unregister]);

  return (
    <div className={st.Root}>
      <Control.Select
        control={control}
        data-testid="callback.type"
        id="select.callback.type"
        label={t('monokit:entities.handlers.ui.forms.callback policy form.callback type select.label') as unknown as string}
        name={`${prefix}type`}
        // @ts-expect-error lack of types POLICIES
        options={callbackTypeOptions ?? POLICIES.CALLBACK.type.raw}
        rules={{ required: validate.required() }}
      />
      {callbackType === 'http' && <HttpCallbackPolicyForm fieldName={fieldName} />}
      {callbackType === 'telegram' && <TelegramNotificationForm fieldName={fieldName} />}
    </div>
  );
}
